var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProdicon002(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(516 1200)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(-516 -1200)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(516 1200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\xCE\\xD3\\xC8_1",
    "data-name": "\\u2014\\xCE\\xD3\\xC8 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M12.593,3.411c8.609,0,5.254,14.266,0,14.266-4.962,0-8.609-14.266,0-14.266Z",
    fill: "#ffe8be",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(0 0)",
    fill: "#a9cf54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M6.734,10.155s.564,7.532-.8,9.565,6.679-.077,6.679-.077l0-14.1Z",
    fill: "#302e33",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M18.489,10.155s-.564,7.532.8,9.565-6.679-.077-6.679-.077l0-14.1Z",
    fill: "#302e33",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M21.358,21.319c-.246-.591-.2-1.18-2.17-2.1-.928-.219-3.321-.534-3.773-1.375A5.17,5.17,0,0,1,15.24,15.7l-5.231-.057A4.577,4.577,0,0,1,9.8,17.79c-.481.792-3.614,1.369-4.587,1.628C3.555,20.154,3.745,20.6,3.526,21.2a12.5,12.5,0,0,0,17.832.119Z",
    fill: "#f9dca4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M15.242,15.687,15.235,16.7a2.327,2.327,0,0,0,.222,1.218c-1.8,1.383-5.176,1.05-5.549-2.4Z",
    fillRule: "evenodd",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M7.731,9.783c-1.2.522-.179,3,.574,2.987a12.476,12.476,0,0,1-.574-2.987Zm9.869,0c1.2.523.179,3-.574,2.987A12.473,12.473,0,0,0,17.6,9.782Z",
    fill: "#f9dca4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M12.587,3.506c3.528,0,5.007,2.508,5.1,5.407.124,3.968-2.3,8.669-5.1,8.669-2.654,0-5.14-4.862-4.989-8.871C7.7,5.9,9.141,3.506,12.587,3.506Z",
    fill: "#ffe8be",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M12.614,5.541c-.234.975-1.335,4.113-5.88,4.614-.473-7.816,5.475-7.625,5.88-7.6.405-.022,6.354-.214,5.88,7.6-4.545-.5-5.646-3.639-5.88-4.614Z",
    fill: "#464449",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M21.358,21.319c-6.015,1.852-13.822.734-16.147-1.9C3.555,20.154,3.745,20.6,3.526,21.2a12.5,12.5,0,0,0,17.832.119Z",
    fill: "#e9573e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M17.313,18.818l.433.1,0,3.284h-.432V18.818Z",
    fill: "#e9573e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M9.642,17.969c0,.005.355,1.8,3.052,1.8s2.85-1.742,2.851-1.747l.076.074S15.392,20,12.693,20c-2.75,0-3.138-1.954-3.139-1.96Z",
    fill: "#464449",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 0.612,
    cy: 0.772,
    rx: 0.612,
    ry: 0.772,
    transform: "translate(12.059 19.23)",
    fill: "#464449"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdicon002);
export default __webpack_public_path__ + "static/media/prodicon002.b88143db5d99ad4f5bab9763ac54f115.svg";
export { ForwardRef as ReactComponent };